<template>
  <v-form>
    <v-progress-linear v-if="loading" indeterminate color="orange"></v-progress-linear>
    <v-card>
      <v-container class="pa-6" v-if="!loading">
        <v-layout row v-if="errors">
          <v-flex>
            <Alert @dismissed="onDismissed" :text="errors"></Alert>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="6" v-if="isAdminRole()">
            <AutocompleteSearch @changeData="form.club = $event" :storeLink="'member/getRoleClubs'"
              :setectVale="form.club" :itemText="'name'" :label="'Select Club'" />
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.international_id" required label="International ID">
            </v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select v-model="form.title" :items="titleList" dense outlined label="Title"></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.display_name" required label="Display Name"></v-text-field>
          </v-col>

          <v-col cols="6">
            <v-text-field outlined dense v-model="form.full_name" required label="Full Name"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-radio-group v-model="form.gender" row label="Gender: ">
              <v-radio :label="item" v-for="(item, index) in genders" :key="index" :value="item"></v-radio>
            </v-radio-group>
          </v-col>

          <v-col cols="6">
            <v-text-field outlined dense v-model="form.mobile" required label="Mobile (7xxxxxx)"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.email" required label="Email"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select v-model="form.member_type_id" :items="memberTypes" :item-text="'type'" :item-value="'id'" dense
              outlined label="Member Type"></v-select>
          </v-col>            
          <v-col cols="6">
            <DatePicker :lable="'Member Since*'" v-model="form.member_since" :setectVale="form.member_since"
              @changeInput="form.member_since = $event"></DatePicker>
          </v-col>
          <v-col cols="6" v-if="isAdminRole()">
            <v-select v-model="form.office_roles" :items="rolesList" :item-text="'role_name'" :item-value="'role_code'"
              dense outlined multiple clearable chips label="Office Roles"></v-select>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.suffix" required label="Suffix"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-text-field outlined dense v-model="form.spouse" required label="Spouse"></v-text-field>
          </v-col>
          <v-col cols="6">
            <v-select v-model="form.status" :items="statusList" dense outlined label="Status"></v-select>
          </v-col>
          <v-col cols="6">
            <v-label>Birthday</v-label>
            <DateOfBirth
              v-model="form.birth_day"
              :setectVale="form.birth_day"
              @changeInput="form.birth_day = $event"
            />           
          </v-col>     
          <v-col cols="6">
            <v-label>Profile Image (200px X 200px)</v-label>
            <FileUpload @changeFile="changeFile" :type="'image/*'" />
            <img v-if="form.profile_image !== ''" :src="form.profile_image" width="150px" />
          </v-col>
        </v-row>
      </v-container>
      <v-divider></v-divider>
      <v-card-actions>
        <v-row>
          <v-col cols="12" md="9" xs="6"> </v-col>
          <v-col cols="12" md="3" xs="6">
            <v-btn large color="green" depressed :disabled="loading" block @click="update()">Update</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <Snackbars :text="successMsg" :snackbar="snackbar" :color="'success'" @classSnackbar="closeSnackbar" />
  </v-form>
</template>

<script>
import Alert from "@/components/shared/Alert";
import { MemberService } from "@/services/member-service.js";
import { CommonService } from "@/services/common-service.js";
import { checkError } from "@/config/errors.js";
import AutocompleteSearch from "@/components/shared/AutocompleteSearch";
import DatePicker from "@/components/shared/DatePicker";
import Snackbars from "@/components/shared/Snackbars";
import FileUpload from "@/components/shared/FileUpload";
import DateOfBirth from "@/components/shared/DateOfBirth";

export default {
  name: "CreateMember",
  components: { Alert, AutocompleteSearch, DatePicker, Snackbars, FileUpload, DateOfBirth },

  data: () => ({
    role: localStorage.getItem("role") || null,
    form: {
      display_name: null,
      full_name: null,
      international_id: null,
      title: null,
      mobile: "",
      email: "",
      gender: "",
      member_type_id: "",
      spouse: "",
      suffix: "",
      status: "",
      club: "",
      office_roles: [],
      member_since: null,
      profile_image: null,
      birth_day:null
    },

    snackbar: false,
    successMsg: "Member has been created successfully",
    errors: null,
    loading: false,
    genders: ["Male", "Female", "Preferred not to say"],
    titleList: ["Mr", "Ms", "Miss", "Mrs", "Dr", "Prof", "Other"],
    statusList: ["active", "inactive"],
    memberTypes: [],
    rolesList: [],
    uuid: null,
    interval:null
  }),

  watch: {},

  mounted() {
    if (this.$route.params.uuid) {
      this.getMemberInfo();
      this.onDismissed();
      this.getOfficeRoleList();
      this.getMemberTypes();
    }
  },

  methods: {
    update() {
      let fd = new FormData();
      fd.append("image", null);
      if (this.form.profile_image) {
        fd.append("image", this.form.profile_image);
      }

      fd.append("display_name", this.form.display_name);
      fd.append("full_name", this.form.full_name);
      fd.append("gender", this.form.gender);
      fd.append("spouse", this.form.spouse);
      fd.append("suffix", this.form.suffix);
      fd.append("title", this.form.title);
      fd.append("mobile", this.form.mobile);
      fd.append("email", this.form.email);
      fd.append("member_type_id", this.form.member_type_id);
      fd.append("status", this.form.status);
      fd.append("international_id", this.form.international_id);
      fd.append("member_since", this.form.member_since);
      fd.append("birth_day", this.form.birth_day);

      if (this.form.profile_image) {
        fd.append("image", this.form.profile_image);
      }

      if (this.isAdminRole()) {
        fd.append("club", this.form.club);
        this.form.office_roles.forEach((file) => {
          fd.append("office_roles[]", file);
        });
      }

      let data = fd;
      this.loading = true;
      this.errors = null;

      MemberService.userUpdate(this.$route.params.uuid, data)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.snackbar = true;
            this.$router.push({name: 'Members'})
          }
        })
        .catch((error) => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          window.scrollTo(0, 0);
        });
    },

    changeFile(event) {
      this.form.profile_image = event;
    },

    getOfficeRoleList() {
      this.loading = true;
      CommonService.getOfficeRoles("")
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.rolesList = response.data.data;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.rolesList = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getUserRoleClubs() {
      CommonService.getUserRoleClubs(this.clubSearch)
        .then((response) => {
          if (response.data.data) {
            this.clubList = response.data.data;
          }
        })
        .catch((error) => {
          this.clubList = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getMemberTypes() {
      this.loading = true;
      CommonService.getMemberTypes()
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
            this.memberTypes = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
          this.memberTypes = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    getMemberInfo() {
      this.loading = true;
      MemberService.getClubMemberInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {           
            this.form = response.data.data;
            this.form.club = response.data.data?.club.uuid;
            this.setRoles(response.data?.data?.office_roles);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.form = [];
          this.form.office_roles = [];
          this.form.club = null;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    setRoles(collection) {
      this.form.office_roles = [];
      if (collection.length > 0) {
        for (let i = 0; i < collection.length; i++) {
          if (collection[i].role) {
            this.form.office_roles.push(collection[i]?.role?.code);
          }
        }
      }
    },

    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },

    reset() {
      this.form = [];
    },

    isAdminRole() {
      if (
        this.role === "DISTRICT_GOVERNOR" ||
        this.role === "REGION_CPE_COORDINATOR" ||
        this.role === "CLUBS_PERFORMANCE_EVALUATION" ||
        this.role === "CLUB_ADMINISTRATOR" ||
        this.role === "CLUB_PRESIDENT" || 
        this.role === 'CLUB_SECRETARY' ||
        this.role ===  'REGION_CHAIRPERSON' ||
        this.role === "CLUB_TREASURER"
      ) {
        return true;
      } else {
        return false;
      }
    },

    isClubRole() {
      if (       
        this.role === 'CLUB_PRESIDENT' ||
        this.role === 'CLUB_SECRETARY' ||
        this.role === 'CLUB_TREASURER' ||
        this.role === 'CLUB_ADMINISTRATOR' 
      ) {
        return true;
      } else {
        return false;
      }
    },

     isRegionRole() {
      if (
        this.role === "REGION_CHAIRPERSON" ||
        this.role === "REGION_GMT_COORDINATOR"      
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
